export default __webpack_public_path__ + "static/media/invalid_document.63904979.svg";